import { SlingoEvent } from "@lib/titan2-slingo/dist/game/controller/event/SlingoEvent";
import { TweenConstants } from "@lib/titan2-slingo/dist/game/view/abstract/constant/TweenConstants";
import { TitanSpine } from "@lib/titan2/dist/game/control/TitanSpine";
import { Linear, gsap } from "gsap";
import { SpineUtil } from "@lib/titan2/dist/util/view/SpineUtil";
import { addToTitanSpineSlot } from "../../../utils/SpineUtils";
import { AbstractGameView } from "@lib/titan2-slingo/dist/game/view/abstract/display/AbstractGameView";
import { TitanText } from "@lib/titan2/dist/game/control/TitanText";
import { CommonGameEvent } from "@lib/titan2/dist/game/controller/event/CommonGameEvent";
import { ViewUtils } from "@lib/titan2/dist/util/view/ViewUtils";
import { Logger } from "@lib/titan2/dist/util/log/Logger";
import { MouseBlocker } from "@lib/titan2/dist/game/control/MouseBlocker";
export class GameScatterWin extends AbstractGameView {
    constructor() {
        super(...arguments);
        this.counterValue = 0;
    }
    addEventListeners() {
        super.addEventListeners();
        super.addEventListeners();
        this.registerGame(CommonGameEvent.PURCHASE_ENTRY, this.reset);
        this.registerGame(SlingoEvent.SCATTER_WIN_ANIMATION, this.handlePlayScatterWin);
    }
    postCreate() {
        super.postCreate();
        this.reset();
        Logger.addObjectRef(this, "GameScatterWin");
    }
    reset() {
        SpineUtil.reset(this.character);
        this.titleContainer.scale.set(0, 0);
        this.counterValue = 0;
        this.counter.setText("");
    }
    create() {
        super.create();
        this.createMouseBlocker();
        this.titleContainer = ViewUtils.createContainer(this);
        this.title0 = TitanText.createField(this.titleContainer, this.landscapeProperties.title0Properties, this.portraitProperties?.title0Properties);
        this.counter = TitanText.createField(this.titleContainer, this.landscapeProperties.counterProperties, this.portraitProperties?.counterProperties);
        this.character = TitanSpine.createSpine(this, this.landscapeProperties.character, this.portraitProperties?.character);
    }
    createMouseBlocker() {
        if (this.uiProperties.mouseBlockerProperties) {
            this.mouseBlocker = new MouseBlocker(this.landscapeProperties.mouseBlockerProperties, this.portraitProperties?.mouseBlockerProperties);
        }
    }
    showOverlay() {
        if (this.mouseBlocker) {
            this.mouseBlocker.alpha = 0;
            this.addChildAt(this.mouseBlocker, 0);
            gsap.to(this.mouseBlocker, { duration: TweenConstants.DEFAULT_OVERLAY_FADE_DURATION, alpha: 1 });
        }
    }
    hideOverlay() {
        this.mouseBlocker && gsap.to(this.mouseBlocker, {
            duration: TweenConstants.DEFAULT_OVERLAY_FADE_DURATION,
            alpha: 0,
            onComplete: () => {
                this.removeChild(this.mouseBlocker);
            }
        });
    }
    showTitle() {
        gsap.to(this.titleContainer.scale, { x: 1, y: 1, duration: TweenConstants.SCATTER_WIN_TITLE_SCALE_DURATION });
    }
    handlePlayScatterWin() {
        this.showTitle();
        this.dispatchGame(SlingoEvent.SCATTER_WIN_APPEAR);
        this.showOverlay();
        this.character.visible = true;
        SpineUtil.play(this.character, "0-in", () => {
            SpineUtil.playLoop(this.character, "0-loop");
        });
        addToTitanSpineSlot(this.character, this.titleContainer, "dynamic-slot");
        addToTitanSpineSlot(this.character, this.counter, "dynamic-slot");
        this.character.getSpine().update(0.01);
        this.counter.visible = true;
        this.dispatchGame(SlingoEvent.SCATTER_WIN_COUNT);
        const payoutConfig = this.model.getPayoutConfig();
        const currentStake = this.model.getCurrentStake();
        const symbolPayouts = payoutConfig.getSymbolPayouts().getValue(undefined).getMultipliers();
        const result = this.model.getSpinResult();
        let symbolWinIndex = 0;
        if (result?.hasSymbolWin() && result.getSymbolWins()[0].getNumberOfSymbols() >= 3) {
            symbolWinIndex = result.getSymbolWins()[0].getNumberOfSymbols() - 1;
        }
        gsap.to(this, {
            counterValue: currentStake * symbolPayouts[symbolWinIndex],
            duration: this.uiProperties.counterTimes[symbolWinIndex],
            ease: Linear.easeNone,
            onUpdate: () => {
                this.counter.setText(this.formatCurrency(this.counterValue));
            },
            onComplete: () => {
                this.dispatchGame(SlingoEvent.SCATTER_WIN_COUNT_END);
                gsap.timeline()
                    .to(this.counter.scale, { x: 1.1, y: 1.1, duration: TweenConstants.YOYO_DURATION, yoyo: true, repeat: 1 })
                    .call(() => {
                    SpineUtil.play(this.character, "0-out", () => {
                        this.character.visible = false;
                        this.reset();
                        this.hideOverlay();
                        this.dispatchGame(SlingoEvent.SCATTER_WIN_DISAPPEAR);
                    }, this);
                }, [], "+=0");
            }
        });
    }
    isPlaying() {
        return this.character.visible;
    }
}
//# sourceMappingURL=GameScatterWin.js.map